/**
 * @file SectionFolder.jsx
 * @author Daniel Aguirre
 * @description SectionFolder Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  ArrowRightOutlined,
  FolderOpenOutlined,
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { Popconfirm } from 'antd';
import { useHistory } from 'react-router-dom';

// Helper
import { getStorageItem } from 'commons/helpers/storage-helper';

// Components
import PanelItem from '../panelItem';

function SectionFolder({
  name,
  link,
  categoryData,
  onEditFunc,
  onDeleteFunc,
  permissions
}) {
  const [isPatient, setIsPatient] = useState(false);
  const { t: translate } = useTranslation();
  const history = useHistory();

  useEffect(async () => {
    setIsPatient(await getStorageItem('isPatient'));
  }, []);

  const icon = (
    <FolderOpenOutlined
      style={{
        fontSize: 30,
        color: 'var(--color-place-holder)',
        textAlign: 'left'
      }}
    />
  );

  const body = (
    <span className="font-bold" style={{ fontSize: 14 }}>
      {name}
    </span>
  );

  const options = isPatient ? (
    <div>
      <ArrowRightOutlined
        className="float-right"
        style={{
          fontSize: 16,
          color: 'var(--color-place-holder)',
          textAlign: 'right'
        }}
      />
    </div>
  ) : (
    <div>
      {!categoryData?.educational_element_count ? (
        <Popconfirm
          title={translate('commons.deleteSection')}
          cancelText={translate('commons.cancel')}
          okText={translate('commons.confirm')}
          onConfirm={onDeleteFunc}
          icon={<QuestionCircleOutlined style={{ color: '#FA7268' }} />}>
          {permissions.delete && (
            <DeleteOutlined
              className="float-right"
              style={{
                fontSize: 16,
                color: 'var(--color-error)'
              }}
            />
          )}
        </Popconfirm>
      ) : (
        <Popconfirm
          title={translate('commons.cantDeleteSection')}
          cancelText={() => null}
          okText={translate('Ok')}
          icon={<QuestionCircleOutlined style={{ color: '#FA7268' }} />}>
          {permissions.delete && (
            <DeleteOutlined
              className="float-right"
              style={{
                fontSize: 16,
                color: 'var(--color-error)'
              }}
            />
          )}
        </Popconfirm>
      )}
      {permissions.update && (
        <EditOutlined
          onClick={onEditFunc}
          className="float-right mr-3"
          style={{
            fontSize: 16,
            color: 'var(--color-place-holder)'
          }}
        />
      )}
    </div>
  );

  return !isPatient ? (
    <PanelItem
      onClick={() => history.push(link, { ...categoryData, permissions })}
      icon={icon}
      body={body}
      options={options}
    />
  ) : (
    <PanelItem
      allClickable={true}
      fullOnClick={() => history.push(link, { ...categoryData, permissions })}
      icon={icon}
      body={body}
      options={options}
    />
  );
}

/**
 * Component definition of proptypes.
 */
SectionFolder.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  onEditFunc: PropTypes.func,
  onDeleteFunc: PropTypes.func,
  categoryData: PropTypes.object,
  permissions: PropTypes.object
};
export default SectionFolder;
